/**
 * Details of the financial institutions that can provide payment services to a
 * submerchant, keyed by the submerchant's financialInstitutionLicence.
 *
 * Returns null for an unknown or missing licence, so callers can hide the
 * statement rather than show something misleading.
 */
export function getFinancialInstitution(licence) {
  switch (licence) {
    case "elgar_payments_gib_psp":
      return {
        name: "Elgar Payments Limited",
        licenceType: "Payment Services Provider",
        regulatoryStatus:
          "regulated by the Gibraltar Financial Services Commission",
        companyNumber: "124266",
        regulator: "Gibraltar Financial Services Commission",
        registerName: "the Gibraltar Financial Services Commission register",
        url: "https://www.fsc.gi/regulated-entity/elgar-payments-limited-29743",
      };
    case "optimus_pay_spi":
      return {
        name: "Optimus Pay Limited",
        licenceType: "Small Payment Institution",
        regulatoryStatus: "registered with the Financial Conduct Authority",
        companyNumber: "07791110",
        regulator: "Financial Conduct Authority",
        registerName: "the Financial Services Register",
        url: "https://register.fca.org.uk/s/firm?id=001b000000NMbzSAAT",
      };
    case "cabcard_services_uk_spi":
      return {
        name: "CabCard Services (UK) Limited",
        licenceType: "Small Payment Institution",
        regulatoryStatus: "registered with the Financial Conduct Authority",
        companyNumber: "06018797",
        regulator: "Financial Conduct Authority",
        registerName: "the Financial Services Register",
        url: "https://register.fca.org.uk/s/firm?id=001b000000NMbzbAAD",
      };
    default:
      return null;
  }
}

/**
 * Prefixes a licence type with the right indefinite article, e.g.
 * "Small Payment Institution" -> "a Small Payment Institution".
 */
export function withIndefiniteArticle(licenceType) {
  if (!licenceType) {
    return licenceType;
  }

  return `${/^[aeiou]/i.test(licenceType) ? "an" : "a"} ${licenceType}`;
}

export default getFinancialInstitution;
